import { useEffect, useState } from 'react';
import { Input } from '@repo/ui';
import { isValidEmail } from '@xtnd/web/shared/utils/validateEmail';

interface ToAddressInputProps {
  value: string;
  onChange: (val: string) => void;
}

export const ToAddressInput = ({ value, onChange }: ToAddressInputProps) => {
  const [localValue, setLocalValue] = useState(value || '');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLocalValue(value || '');
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    if (val !== '' && !isValidEmail(val)) {
      setError('Invalid email');
    } else {
      setError(null);
    }
    setLocalValue(val);
  };

  return (
    <div className="flex flex-col gap-1">
      <Input
        className="!py-2"
        value={localValue}
        label="To"
        fullWidth
        required
        type="email"
        onChange={e => {
          handleChange(e);
        }}
        onBlur={() => onChange(localValue)}
      />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};
